/*
 * Developed for EPSON AMERICA INC. by Softeq Development Corporation
 * http://www.softeq.com
 */

import queryString from 'query-string'
import _get from 'lodash/get'
import env from 'env'

const queryToStringParams = (query = {}) => queryString.stringify(query)

const getPath = ({ pathname = '', query, hostname }) => {
  const host = hostname ? hostname : env.api
  const resPath = `${host}${pathname[0] === '/' ? '' : '/'}${pathname}`

  return query
    ? `${resPath}?${queryToStringParams(query)}`
    : resPath
}

export const getApiUrl = params => getPath(params)

const paramRegExp = /:[A-Za-z0-9]+/g
export const getPathWithParams = (path, params) => path.replace(paramRegExp, replacedValue => {
  return _get(params, replacedValue.replace(':', ''))
})

export const getPathWithQuery = (path, query) => `${path}?${queryToStringParams(query)}`

export const getQueryFromSearch = (search = '') => queryString.parse(search.substr(1))

const createHistory = () => {
  let history = {}
  return {
    setHistory: routerHistory => {
      history = routerHistory
    },
    replace: pathname => history.replace(pathname),
    push: pathname => history.push(pathname),
  }
}

export const history = createHistory()
